<div class="splash-screen">
    <div class="logo-container">
        <img ngSrc="assets/images/logo/logoanvt1.jpg" alt="ANVT Logo" height="1080" width="1080">
    </div>
    <p class="loading-text">Chargement en cours...</p>
</div>
